export const totemActionsReport = {
	title: "Acciones en el Tótem",
	description: "Lista de todas las acciones a lo largo del evento.",
	filters: {
		totem: {
			label: "Tótem",
			placeholder: "Ingrese o seleccione el tótem",
		},
		transaction: {
			label: "Tipo de transacción",
			placeholder: "Ingrese o seleccione el tipo",
		},
		search: {
			label: "Buscar",
			placeholder: "Buscar por ID",
		},
	},
	columns: {
		date: "FECHA Y HORA",
		transactionType: "TIPO DE TRANSACCIÓN",
		totem: "TÓTEM",
		user: "CLIENTE",
		value: "VALOR",
		paymentMethod: "FORMA DE PAGO",
	},
	filename: "reporte-acciones-en-el-totem",
};
